const NYKAA_USER_KEY = 'NYKAA_CUSTOMER_VERIFIED';

export const isUserInitiated = () => window.localStorage.getItem(NYKAA_USER_KEY) !== null;

export const setUserInitiated = () => window.localStorage.setItem(NYKAA_USER_KEY, '1');
